import { FC, useContext, useEffect } from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";

import useFetch from "src/hooks/useFetch";
import HubInputField from "src/components/inputType";
import IOveraComps from "../addCase/ioveraComps";
import ZilrettaComp from "../addCase/zilrettaComps";

import { APIEndpoints } from "src/types/apiTypes";
import { CaseStepOneProps } from "./types";
import { ProductRequestProps } from "../manufacturer/statistics/types";
import { CaseContext } from "src/context/caseContext";
import { AuthContext } from "src/context/authContext";
import { isIoveraUser, isZilrettaUser } from "src/helpers";
import { DEFAULT_PRESCRIPTION_INFO } from "src/constants/cases";



const CaseStepOne: FC<CaseStepOneProps> = ({ control, isVisible, watch, setValue, getValues, trigger }): JSX.Element => {
  const drug_name = watch("prescription_attributes.drug_name");
  const hasBeenTreated = watch("prescription_attributes.has_been_treated")

  const { data: productData } = useFetch<ProductRequestProps[]>(APIEndpoints.GET_PRODUCTS);
  const { formControls } = useContext(CaseContext)
  const { userData } = useContext(AuthContext)

  useEffect(() => {
    if (productData && productData.length > 0) {
      if (drug_name === "") {
        const firstDrug = productData.find((item) => item.id === 1);
        if (firstDrug)
          setValue("prescription_attributes.drug_name", firstDrug.name.toLowerCase().replace(/°/g, ""));
      } else if (isIoveraUser(userData)) {
        setValue("prescription_attributes.drug_name", "iovera");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData]);

  useEffect(() => {
    if (drug_name && hasBeenTreated) {
      if (formControls) {
        formControls.resetField("prescription_attributes.has_been_treated")
        formControls.resetField("prescription_attributes.last_date_of_service")
      }
    }
    if (drug_name && formControls) {
      if (drug_name.includes("iovera")) {
        formControls.setValue("prescription_attributes.direction", "")
        formControls.setValue("category", "medrx")
      } else {
        formControls.setValue("category", "")
        formControls.setValue("prescription_attributes.direction", DEFAULT_PRESCRIPTION_INFO.direction)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drug_name])

  useEffect(() => {
    if (hasBeenTreated && ["No", "Unsure"].includes(hasBeenTreated)) {
      trigger("prescription_attributes.last_date_of_service")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasBeenTreated])



  return (
    <div className={`card mb-3 ${!isVisible ? 'd-none' : ''}`}>
      <div className= {`card-header ${drug_name === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">Getting Started</h4>
      </div>

      <div className="card-body">
        <p>
          In order to process your request for benefit investigation, the following information must be completed.
          All information is kept confidential according to HIPAA guidelines. Please fill out the fields below as
          completely as possible. Missing fields may result in a delay to processing patient benefits in a timely manner.
        </p>

        <div className="row align-items-center">
          <div className='col-lg-6'>
            <Controller
              name="prescription_attributes.drug_name"
              control={control}
              render={({ field, fieldState: { error } }) => {
                return userData && (isZilrettaUser(userData) || isIoveraUser(userData)) ? (
                  <div className="row align-items-center mb-3">
                    <label htmlFor="prescription_attributes.drug_name" className="form-label col-lg-4 col-md-4 col-12">
                      Product *
                    </label>
                    <div className="col-lg-8 col-md-8 col-12">
                      <p className="fs-6 mb-0">{isIoveraUser(userData) ? "iovera°" : field.value.toUpperCase()}</p>
                    </div>
                  </div>
                ) :(
                  <HubInputField
                    inputId="prescription_attributes.drug_name"
                    inputLabel="Product"
                    isRequired={true}
                    isRowBased={true}
                    isRowInsideAnother={true}
                    field={field}
                    error={error}
                    isDropdown={true}
                    isSearchable={false}
                    inputPlaceholder="Select a Product ..."
                    isTypeAhead
                    dropdownData={
                      (productData ?
                        productData.map((item) => ({ value: item.name.toLowerCase(), label: item.name.toLowerCase() === "zilretta" ? item.name.toUpperCase() : item.name.replace(/°/g, "") })).map(
                          (procedure) => ({ value: procedure.value, label: procedure.label })
                        ) : []
                      ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                );
              }}
            />
          </div>
        </div>

        {drug_name === "iovera°" || drug_name === "iovera"  ?
          <IOveraComps control={control} setValue={setValue} watch={watch} getValues={getValues} /> :
          <ZilrettaComp control={control} watch={watch} setValue={setValue} />
        }

        <Controller
          name="prescription_attributes.drug_name"
          control={control}
          render={() => <></>}
        />
      </div>
    </div>
  )
};

export default CaseStepOne;
